export enum AppointmentTypes {
  Event = 'event',
  Appointment = 'appointment'
}
export enum AppointmentState {
  Confirmed = 'confirmed',
  Finished = 'finished',
  Draft = 'draft'
}


// WEBPACK FOOTER //
// ./src/common/enums/appointment-types.enum.ts